import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  width: 1350,
  height: 760,
  x: 50,
  y: 50,
  list: [
    {
      id: 'e581810b-8399-4124-93a0-fc1319100c21',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '2f1fbd2f-6fb8-41cc-be8c-a1e3c2b31fa3',
      type: 'Graphics',
      name: 'ovelay',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e581810b-8399-4124-93a0-fc1319100c21',
      bake: false,
      commands: [],
      data: ''
    },
    {
      id: 'ad784f41-f3c0-41b7-9491-bd3276f95ed6',
      type: 'Container',
      name: 'wheelContainer',
      nameSpace: '',
      className: '',
      x: -313,
      y: 39,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e581810b-8399-4124-93a0-fc1319100c21',
      data: ''
    },
    {
      id: '73db4ea3-3ba9-4bb9-bb1f-59c6c7020b98',
      type: 'Container',
      name: 'panelContainer',
      nameSpace: '',
      className: '',
      x: 322,
      y: 22,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'e581810b-8399-4124-93a0-fc1319100c21',
      data: ''
    },
    {
      id: 'e108172b-c813-4bc3-9275-23027ef6c4fd',
      type: 'Sprite',
      name: 'closeButton',
      nameSpace: '',
      className: '',
      x: 625,
      y: -330,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'premium_wheel_close_button',
      parent: 'e581810b-8399-4124-93a0-fc1319100c21',
      data: ''
    },
    {
      id: '8d154a90-baeb-4130-b72c-61ec5272ded2',
      type: 'Container',
      name: 'haloContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'ad784f41-f3c0-41b7-9491-bd3276f95ed6',
      data: ''
    },
    {
      id: '3391658d-2777-4e7b-8661-e6dd3892b86e',
      type: 'Container',
      name: 'haloWinContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'ad784f41-f3c0-41b7-9491-bd3276f95ed6',
      data: ''
    },
    {
      id: '76ed9ea5-7c8a-4720-9bd7-85b90d31a79d',
      type: 'Container',
      name: 'wheelPrizes',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'ad784f41-f3c0-41b7-9491-bd3276f95ed6',
      data: ''
    },
    {
      id: 'f5135204-0542-49c0-ab5d-374752f983a9',
      type: 'Sprite',
      name: 'wheelMultipliers',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'premium_wheel_multipliers',
      parent: 'ad784f41-f3c0-41b7-9491-bd3276f95ed6',
      data: ''
    },
    {
      id: '18463b49-ca3d-4c6f-aa74-0092df308527',
      type: 'Container',
      name: 'sectorLightUpContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'ad784f41-f3c0-41b7-9491-bd3276f95ed6',
      data: ''
    },
    {
      id: 'e12e6c2c-d7d2-4fdf-b0a0-0962fdea3090',
      type: 'Container',
      name: 'wheelBaseContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'ad784f41-f3c0-41b7-9491-bd3276f95ed6',
      data: ''
    },
    {
      id: 'b2c854d8-7578-43f1-a970-7afc4c8f4cbc',
      type: 'Container',
      name: 'sectorParticleContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'ad784f41-f3c0-41b7-9491-bd3276f95ed6',
      data: ''
    },
    {
      id: '7a4240d1-8776-4747-a622-4a98ffe35270',
      type: 'Sprite',
      name: 'multiplierPanel',
      nameSpace: '',
      className: '',
      x: 0,
      y: -348,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'premium_top_board',
      parent: 'ad784f41-f3c0-41b7-9491-bd3276f95ed6',
      data: ''
    },
    {
      id: '5089b754-5419-4cb7-a907-cab44963b13f',
      type: 'Sprite',
      name: 'bigWheelPointer',
      nameSpace: '',
      className: '',
      x: 0,
      y: -293,
      anchor: {
        x: 0.5,
        y: 0.36
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'premium_arrow_1',
      parent: 'ad784f41-f3c0-41b7-9491-bd3276f95ed6',
      data: ''
    },
    {
      id: 'cfc91a10-3c4e-4868-8d48-41e6161332e5',
      type: 'Sprite',
      name: 'smallWheelPointer',
      nameSpace: '',
      className: '',
      x: 0,
      y: -117,
      anchor: {
        x: 0.5,
        y: 0.36
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'premium_arrow_2',
      parent: 'ad784f41-f3c0-41b7-9491-bd3276f95ed6',
      data: ''
    },
    {
      id: '15479642-8eca-4986-ac32-9abf4e88117a',
      type: 'Container',
      name: 'titleRaysContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: -105,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '73db4ea3-3ba9-4bb9-bb1f-59c6c7020b98',
      data: ''
    },
    {
      id: 'dc4b12ca-8b37-4001-9af9-4ce154221033',
      type: 'Sprite',
      name: 'spinPanel',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'premium_ui_window',
      parent: '73db4ea3-3ba9-4bb9-bb1f-59c6c7020b98',
      data: ''
    },
    {
      id: '74d603b6-2056-48bf-b025-cfeecbb5e8b4',
      type: 'Sprite',
      name: 'sharePanel',
      nameSpace: '',
      className: '',
      x: 0,
      y: 18,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'premium_ui_window_share',
      parent: '73db4ea3-3ba9-4bb9-bb1f-59c6c7020b98',
      data: ''
    },
    {
      id: 'fd0174af-39c0-4602-8307-7f5c38431c47',
      type: 'Container',
      name: 'titleContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: -140,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '73db4ea3-3ba9-4bb9-bb1f-59c6c7020b98',
      data: ''
    },
    {
      id: '42663b13-2fb2-4bda-8139-a4c8cd45874c',
      type: 'Text',
      name: 'availableAmount',
      nameSpace: '',
      className: '',
      x: 0,
      y: 208,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '3x available',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 24,
        fontWeight: 'normal',
        fontFamily: 'Arial',
        fill: '#ffffff',
        stroke: '#112C58',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '73db4ea3-3ba9-4bb9-bb1f-59c6c7020b98',
      data: ''
    },
    {
      id: '58cf9549-cc63-4dd1-8d44-d7039ea9c4d9',
      type: 'Container',
      name: 'sectorsContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '76ed9ea5-7c8a-4720-9bd7-85b90d31a79d',
      data: ''
    },
    {
      id: '669339ec-9854-4a52-826a-f9a54cb6aa5f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'premium_wheel_rail',
      parent: '76ed9ea5-7c8a-4720-9bd7-85b90d31a79d',
      data: ''
    },
    {
      id: '3f4ddb76-9b60-40c6-b4bf-aae3cb32d1bd',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: 'multipliers',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 2.2
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x3',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#0C3F5C',
        stroke: '#E9A41E',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'f5135204-0542-49c0-ab5d-374752f983a9',
      data: ''
    },
    {
      id: 'b17ee6aa-848a-4dab-ba3b-ad432eed0d3c',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: 'multipliers',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 2.2
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 45,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x3',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#D6DFE9',
        stroke: '#E9A41E',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'f5135204-0542-49c0-ab5d-374752f983a9',
      data: ''
    },
    {
      id: 'a377cea5-812c-4655-97a2-9ca2aafdbe15',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: 'multipliers',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 2.2
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 90,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x3',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#0C3F5C',
        stroke: '#E9A41E',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'f5135204-0542-49c0-ab5d-374752f983a9',
      data: ''
    },
    {
      id: '4d423b4f-6783-4d88-92a8-d03b9127c92c',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: 'multipliers',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 2.2
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 135,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x3',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#D6DFE9',
        stroke: '#E9A41E',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'f5135204-0542-49c0-ab5d-374752f983a9',
      data: ''
    },
    {
      id: '911965ea-7cee-47c1-b507-6af0d42eec80',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: 'multipliers',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 2.2
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 180,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x3',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#0C3F5C',
        stroke: '#E9A41E',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'f5135204-0542-49c0-ab5d-374752f983a9',
      data: ''
    },
    {
      id: 'ce9df7f7-431c-43f7-bcbc-c377464a5800',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: 'multipliers',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 2.2
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 225,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x3',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#D6DFE9',
        stroke: '#E9A41E',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'f5135204-0542-49c0-ab5d-374752f983a9',
      data: ''
    },
    {
      id: 'a73195b6-99c3-4e9f-aec6-2f4e44855aa3',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: 'multipliers',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 2.2
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 270,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x3',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#0C3F5C',
        stroke: '#E9A41E',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'f5135204-0542-49c0-ab5d-374752f983a9',
      data: ''
    },
    {
      id: '440e3c59-4241-42fe-896e-bf987371a0dc',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: 'multipliers',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 2.2
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 315,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'x3',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 32,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#D6DFE9',
        stroke: '#E9A41E',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'f5135204-0542-49c0-ab5d-374752f983a9',
      data: ''
    },
    {
      id: '3d71c7fa-3e2a-41dd-b2c6-ecf9f5057de6',
      type: 'Text',
      name: 'multiplierText',
      nameSpace: '',
      className: '',
      x: 3,
      y: -22,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'X3',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 54,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#610B62',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 5
      },
      parent: '7a4240d1-8776-4747-a622-4a98ffe35270',
      data: ''
    },
    {
      id: 'a1dbe677-3bb0-431f-a55c-224542cea5b2',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -53,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'WinUpTo',
      localize: true,
      maxWidth: 475,
      maxHeight: 105,
      maxFontSize: 36,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffffff',
        stroke: '#112C58',
        strokeThickness: 4,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'dc4b12ca-8b37-4001-9af9-4ce154221033',
      data: ''
    },
    {
      id: '3c8c1fa4-f2f4-4fea-b08f-7aad45a179f5',
      type: 'Text',
      name: 'coinRewardText',
      nameSpace: '',
      className: '',
      x: 20,
      y: -6,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'RewardCoins!',
      localize: true,
      maxWidth: 475,
      maxHeight: 105,
      maxFontSize: 36,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffffff',
        stroke: '#112C58',
        strokeThickness: 4,
        align: 'center',
        wordWrap: true,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'dc4b12ca-8b37-4001-9af9-4ce154221033',
      data: ''
    },
    {
      id: '1808b9c6-95e7-4209-aca6-0319c50615ef',
      type: 'Container',
      name: 'spinButtonContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 109,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'dc4b12ca-8b37-4001-9af9-4ce154221033',
      data: ''
    },
    {
      id: 'ee8dd272-2044-432f-84d4-8def2e871d0f',
      type: 'Container',
      name: 'stopButtonContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: 109,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'dc4b12ca-8b37-4001-9af9-4ce154221033',
      data: ''
    },
    {
      id: '6d99269e-897e-4ea6-a894-50be0150f0c4',
      type: 'Container',
      name: 'claimButtonContainer',
      nameSpace: '',
      className: '',
      x: -101,
      y: 135,
      scale: {
        x: 1.25,
        y: 1.25
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '74d603b6-2056-48bf-b025-cfeecbb5e8b4',
      data: ''
    },
    {
      id: '47da941d-8498-4962-a4ee-b5de0d26cd94',
      type: 'Container',
      name: 'rewardContainer',
      nameSpace: '',
      className: '',
      x: 0,
      y: -15,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '74d603b6-2056-48bf-b025-cfeecbb5e8b4',
      data: ''
    },
    {
      id: '1a8e8ff4-24f5-4f32-9b23-290ab61e5ed1',
      type: 'Sprite',
      name: 'coinSprite',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'UI_CoinsGift_coin',
      parent: '3c8c1fa4-f2f4-4fea-b08f-7aad45a179f5',
      data: ''
    },
    {
      id: '8b6b44d0-5f45-4ef7-9e90-0631abf836c1',
      type: 'Sprite',
      name: 'spinButton',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.13,
        y: 1.13
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_buy',
      parent: '1808b9c6-95e7-4209-aca6-0319c50615ef',
      data: ''
    },
    {
      id: 'ba7782af-883f-408e-8c31-a7ae3761dc7e',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'premium_frame_button',
      parent: '1808b9c6-95e7-4209-aca6-0319c50615ef',
      data: ''
    },
    {
      id: '087394e1-fb75-4e08-966d-9d9683ef66ee',
      type: 'Sprite',
      name: 'stopButton',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_stop',
      parent: 'ee8dd272-2044-432f-84d4-8def2e871d0f',
      data: ''
    },
    {
      id: 'c65c7cc1-4219-4ff1-88b4-540c95005f13',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'premium_frame_button',
      parent: 'ee8dd272-2044-432f-84d4-8def2e871d0f',
      data: ''
    },
    {
      id: 'c3235a1d-ff8f-485b-8ff1-ca22a802337e',
      type: 'Sprite',
      name: 'shareButton',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_share',
      parent: 'd86dccdc-28fe-4a67-8bd5-8b510965fb16',
      data: ''
    },
    {
      id: 'bfb421f6-de66-47e2-9923-49b7bffe6e92',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'premium_frame_button_share',
      parent: 'd86dccdc-28fe-4a67-8bd5-8b510965fb16',
      data: ''
    },
    {
      id: '27b96a4f-d77d-4e72-be5b-d1a1fc6e9261',
      type: 'Sprite',
      name: 'claimButton',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'button_claimreward',
      parent: '6d99269e-897e-4ea6-a894-50be0150f0c4',
      data: ''
    },
    {
      id: '21409213-8ad1-4f7d-8194-c71a92e69c6f',
      type: 'Sprite',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: 3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'premium_frame_button_share',
      parent: '6d99269e-897e-4ea6-a894-50be0150f0c4',
      data: ''
    },
    {
      id: '70e4013d-e2ea-426a-9c75-4ccd1da59b36',
      type: 'Text',
      name: 'spinText',
      nameSpace: '',
      className: '',
      x: 0,
      y: -8,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.88,
        y: 0.88
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Spin 1.99$',
      localize: false,
      maxWidth: 233,
      maxHeight: 71,
      maxFontSize: 48,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#5E01BD',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '8b6b44d0-5f45-4ef7-9e90-0631abf836c1',
      data: ''
    },
    {
      id: '9d4a1f7e-33cc-43b9-9e82-a0cfdc9f39a6',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -8,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Stop',
      localize: true,
      maxWidth: 233,
      maxHeight: 89,
      maxFontSize: 52,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#97242D',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '087394e1-fb75-4e08-966d-9d9683ef66ee',
      data: ''
    },
    {
      id: 'afabaceb-ae1f-4997-9895-b4e2ead0f4a1',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Share',
      localize: true,
      maxWidth: 178,
      maxHeight: 49,
      maxFontSize: 32,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#00386E',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: 'c3235a1d-ff8f-485b-8ff1-ca22a802337e',
      data: ''
    },
    {
      id: '8fea1c2f-81a7-4fed-8359-8a1482a69c78',
      type: 'Text',
      name: '',
      nameSpace: '',
      className: '',
      x: 0,
      y: -4,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'ClaimReward',
      localize: true,
      maxWidth: 223,
      maxHeight: 61,
      maxFontSize: 40,
      icons: [],
      style: {
        fontSize: 26,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: '#ffffff',
        stroke: '#13742B',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '27b96a4f-d77d-4e72-be5b-d1a1fc6e9261',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class PremiumWheelLayout {
  static raw = raw;
  root: PIXI.Container
  ovelay: PIXI.Graphics
  wheelContainer: PIXI.Container
  haloContainer: PIXI.Container
  haloWinContainer: PIXI.Container
  wheelPrizes: PIXI.Container
  sectorsContainer: PIXI.Container
  wheelMultipliers: PIXI.Sprite
  sectorLightUpContainer: PIXI.Container
  wheelBaseContainer: PIXI.Container
  sectorParticleContainer: PIXI.Container
  multiplierPanel: PIXI.Sprite
  multiplierText: PIXI.Text
  bigWheelPointer: PIXI.Sprite
  smallWheelPointer: PIXI.Sprite
  panelContainer: PIXI.Container
  titleRaysContainer: PIXI.Container
  spinPanel: PIXI.Sprite
  coinRewardText: PIXI.Text
  coinSprite: PIXI.Sprite
  spinButtonContainer: PIXI.Container
  spinButton: PIXI.Sprite
  spinText: PIXI.Text
  stopButtonContainer: PIXI.Container
  stopButton: PIXI.Sprite
  sharePanel: PIXI.Sprite
  shareButtonContainer: PIXI.Container
  shareButton: PIXI.Sprite
  claimButtonContainer: PIXI.Container
  claimButton: PIXI.Sprite
  rewardContainer: PIXI.Container
  titleContainer: PIXI.Container
  availableAmount: PIXI.Text
  closeButton: PIXI.Sprite
  multipliers: (PIXI.Text)[]

  constructor() {
    populate(this, raw);
  }
}
